<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" hide-footer :onClose="onClose">
    <div v-if="issueData">
      <div class="tabs">
        <div :class="{ 'active-tab': activeTab === 'info' }" @click="changeTab('info')">INFORMACIÓN</div>
        <div :class="{ 'active-tab': activeTab === 'comments' }" @click="changeTab('comments')">COMENTARIOS</div>
        <div :class="{ 'active-tab': activeTab === 'documents' }" @click="changeTab('documents')">DOCUMENTOS</div>
      </div>
      <div v-if="activeTab === 'info'" class="tab-content mt-3">
        <div class="row">
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">ID</div>
            <div>{{ issueData.incidentId }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Descripción</div>
            <div>{{ issueData.description }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Título</div>
            <div>{{ issueData.title }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Usuario solicitante</div>
            <div>{{ issueData.requesterUsername }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Usuario asignado</div>
            <div>{{ issueData.assignedTo }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Nº Contrato</div>
            <div>{{ issueData.contractId }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Tipo</div>
            <div>{{ type }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Estado</div>
            <div>{{ status }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Prioridad</div>
            <div>{{ priority }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Fecha creación</div>
            <div>{{ $dateBackToFront(issueData.createdAt) }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Fecha de cierre</div>
            <div>{{ $dateBackToFront(issueData.closedAt) }}</div>
          </div>
          <div class="col-12 mb-3 mt-1">
            <div class="generalTitleItemModal">Usuario de cierre</div>
            <div>{{ issueData.closerUsername }}</div>
          </div>
        </div>
      </div>
      <div v-if="activeTab === 'comments'" class="tab-content">
        <NewComment :issue="issueData" @sendRefreshIssuesList="sendRefreshIssue($event)"></NewComment>
        <div class="row mb-5">
          <div v-if="Array.isArray(issueData.comments) && issueData.comments.length > 0">
          <div v-for="(comment, index) in issueData.comments" class="col-12 mb-3 mt-1" v-bind:key="index">
            <div class="generalTitleItemModal">{{ comment.createdBy }} - {{ $dateBackToFront(comment.createdAt, true) }}</div>
            <div>{{ comment.comment }}</div>
            <div class="line"></div>
          </div>
        </div>
        <div v-else>No hay comentarios</div>
      </div>
      </div>

      <div v-if="activeTab === 'documents'" class="tab-content">
        <div class="row mt-5">
          <div class="col-12 mb-3 mt-1" v-bind:key="index">
          <DropDocuments :issue="issue.incidentId" @sendRefreshIssue=sendRefreshIssue($event); />
          </div>
        <div v-if="Array.isArray(issueData.documents) && issueData.documents.length > 0">
          <div v-for="(document, index) in issueData.documents" class="col-12 mb-3 mt-1" v-bind:key="index">
            <div style="cursor: pointer;" @click="downloadDocument(document)"> 
              <div class="d-flex">
                <v-icon class="mr-3 text-primary" name="bi-download" scale="1.2" />
                <div class="mb-3  mr-3 text-muted"> {{ $dateBackToFront(document.createdAt, true) }}</div>
                <div>{{ document.filename }}</div>              
              </div>                       
              <div>{{ document.description }}</div>
            </div>
            <div class="line"></div>
          </div>        
        </div>
        <div v-else>No hay documentos</div>
      </div>
      </div>
    </div>
    <button :id="id + 'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
</template>
<script>
import Modal from "../../../Shared/Modal.vue";
import axios from 'axios';
import { priorityData, priorityDataTraduction, statusData, statusDataTraduction, incidentsTypes, incidentsTypesTraduction } from "../common.js";
import DropDocuments from "./DropDocuments.vue";
import NewComment from "./NewComment.vue"


export default {
  name: "IssueDetail",
  props: [
    'id',
    'modalTitle',
    'class',
    'issue',
    'message'
  ],
  data() {
    return {
      classes: this.class,
      issueData: this.issue,
      priorityData: priorityData,
      priorityDataTraduction: priorityDataTraduction,
      statusData: statusData,
      statusDataTraduction: statusDataTraduction,
      activeTab: 'info',
      incidentsTypes: incidentsTypes,
      incidentsTypesTraduction: incidentsTypesTraduction,
    };
  },
  components: {
    Modal,
    DropDocuments,
    NewComment
},
  computed: {
    priority() {
      return this.priorityData[this.priorityDataTraduction.indexOf(this.issueData.priority)]
    },
    status() {
      return this.statusData[this.statusDataTraduction.indexOf(this.issueData.status)]
    },
    type() {
      return this.incidentsTypes[this.incidentsTypesTraduction.indexOf(this.issueData.type)]
    },
  },
  methods: {
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
    },
    downloadDocument(document) {
      axios.get(`incident/${this.issueData.incidentId}/document/${document.bucketName}`)
        .then((response) => {
          window.open(response.data, '_blank');
        });
    },
    changeTab(tab) {
      this.activeTab = tab;
    },
    sendRefreshIssue(idIncident) {
      axios.get(`/incidents?&id=${idIncident}&pagination.pageSize=1&pagination.page=1`)
        .then((response) => {
          this.loading = false;
          this.issueData = response.data.incidents[0];
        });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.tabs {
  display: flex;
  width: 100%;
}
.tabs div {
  flex: 1;
  padding: 0px 10px 10px 10px;
  text-align: center;
  cursor: pointer;
  border-bottom: 2px solid #ccc;
}
.active-tab {
  color: #cc0b7a;
  border-bottom: 3px solid #cc0b7a !important;
}
.tab-content {
  width: 100%;
  padding-top: 20px;
}
.line {
  width: 100px;
  height: 1px;
  color: #C6C6C6;
  border-bottom: 1px solid #C6C6C6;
  margin-top: 20px;
  margin-bottom: 20px;
}

</style>
